
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/passport-photo-maker",
      function () {
        return require("private-next-pages/passport-photo-maker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/passport-photo-maker"])
      });
    }
  